// extracted by mini-css-extract-plugin
export default {"container":"Likert_container__6hHV3","title":"Likert_title__KzuXS","selected":"Likert_selected__f+7nB","littleTitle":"Likert_littleTitle__tAe6Q"};